/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type Web3MigrationQueryVariables = Types.Exact<{ [key: string]: never }>;

export type Web3MigrationQuery = {
	__typename?: "Query";
	web3Migration: { __typename?: "Web3MigrationStatus"; signedUp: boolean };
};

export const Web3MigrationDocument = gql`
	query web3Migration {
		web3Migration {
			signedUp
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class Web3MigrationGQLService extends Apollo.Query<Web3MigrationQuery, Web3MigrationQueryVariables> {
	document = Web3MigrationDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
